export const STATE_NAME = "notificationPopup";
